import { createAction } from '@reduxjs/toolkit';

export const saveClick = createAction('[Order] saveClick');
export const create = createAction('[Order] create');
export const setcreateInProgress = createAction('[Order] setcreateInProgress');
export const createSuccess = createAction('[Order] createSuccess');
export const setValid = createAction('[Order] setValid');
export const validateForm = createAction('[Order] validateForm');
